import { useGetBestBidForListing } from '@app/hooks/nft/useGetBestBidForListing';
import { useMemo } from 'react';
import { AUCTION_TYPES } from '@app/constants/nftMarketplace';
import { formatUnits } from 'ethers/lib/utils';
import { calculateDiscountOrPremium } from '@app/helpers/calculateDiscountOrPremium';
import { NFTMarketplaceListing } from '@app/types/nftMarketplace';
import { Token } from '@app/types/token';

export function useDiscountValue(
  listing: NFTMarketplaceListing,
  currency: Token,
  deposit: number | null
) {
  const { data } = useGetBestBidForListing(listing.id);

  const value = useMemo(() => {
    if (listing.type !== AUCTION_TYPES.ENGLISH_AUCTION) {
      return formatUnits(listing.price, currency.decimals);
    }

    if (!data) {
      return null;
    }

    const parsedAmount = data.amount?.toString() ?? 0;

    return formatUnits(
      parsedAmount && parsedAmount !== '0' ? parsedAmount : listing.reserve,
      currency.decimals
    );
  }, [data, listing, currency]);

  return calculateDiscountOrPremium(deposit, value);
}
